/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import {
    appleSocialMedia,
    appleSocialMediaCheck,
    buyerLogIn,
    buyerUserDetail,
    facebookSocialMedia,
    facebookSocialMediaCheck,
    googleSocialMedia,
    googleSocialMediaCheck,
    orderUpdate,
    paymentSuccess,
    register,
    userUpdate,
    userVerify,
    userDelete,
    verifyMobileOtp,
    checkOtp,
    resendPhoneOtp,
    reactivation,updateuser
} from '../settings/apiconfig';
import { getBuyerHeaders, getBuyersUrl } from 'shared/http';
import interfaceService from './interfaceService';

class AuthService {
    constructor() {
        this.service = interfaceService.getService();
    }

    logIn(data) {
        return this.service.post(getBuyersUrl(buyerLogIn), JSON.stringify(data), getBuyerHeaders(false));
    }

    registerAPI(data) {
        return this.service.post(getBuyersUrl(register), JSON.stringify(data), getBuyerHeaders());
    }

    googleAuthCheck(data) {
        return this.service.post(getBuyersUrl(googleSocialMediaCheck), JSON.stringify(data), getBuyerHeaders());
    }

    googleAuth(data) {
        return this.service.post(getBuyersUrl(googleSocialMedia), JSON.stringify(data), getBuyerHeaders());
    }

    facebookAuthCheck(data) {
        return this.service.post(getBuyersUrl(facebookSocialMediaCheck), JSON.stringify(data), getBuyerHeaders());
    }

    facebookAuth(data) {
        return this.service.post(getBuyersUrl(facebookSocialMedia), JSON.stringify(data), getBuyerHeaders());
    }

    appleAuthCheck(data) {
        return this.service.post(getBuyersUrl(appleSocialMediaCheck), JSON.stringify(data), getBuyerHeaders());
    }

    appleAuth(data) {
        return this.service.post(getBuyersUrl(appleSocialMedia), JSON.stringify(data), getBuyerHeaders());
    }

    getUserDetails(userId) {
        return this.service.get(getBuyersUrl(`${buyerUserDetail}/${userId}`), getBuyerHeaders());
    }

    profileUpdate(data) {
        return this.service.put(getBuyersUrl(userUpdate), JSON.stringify(data), getBuyerHeaders());
    }

    paymentSuccess(data) {
        return this.service.post(getBuyersUrl(paymentSuccess), JSON.stringify(data), getBuyerHeaders());
    }

    orderUpdate(data) {
        return this.service.put(getBuyersUrl(orderUpdate), JSON.stringify({ data }), getBuyerHeaders());
    }

    checkDetails(data) {
        return this.service.post(getBuyersUrl(userVerify), JSON.stringify(data), getBuyerHeaders(false));
    }
    deleteAccount(data) {
        return this.service.delete(getBuyersUrl(userDelete), getBuyerHeaders(true, 'json', data));
    }
    verifyMobileOtp(data) {
        return this.service.post(getBuyersUrl(verifyMobileOtp),JSON.stringify(data), getBuyerHeaders(false))
    }
    checkOtpVerify(data) {
        return this.service.post(getBuyersUrl(checkOtp), JSON.stringify(data), getBuyerHeaders(false))
    }
    resendOtp(data) {
        return this.service.post(getBuyersUrl(resendPhoneOtp), JSON.stringify(data), getBuyerHeaders(false))
    }
    reActivation(data) {
        return this.service.post(getBuyersUrl(reactivation), JSON.stringify(data), getBuyerHeaders(false))
    }
    updateUser(data) {
        return this.service.post(getBuyersUrl(updateuser), JSON.stringify(data), getBuyerHeaders(false))
    }


}

export default new AuthService();